export const getCurrentBuildVersion = () =>
  fetch(process.env.PUBLIC_URL + "/build.txt").then(r => r.text());
